module.exports = __webpack_public_path__ + "img/goldens_location_mark.5d72098e.svg";